import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { comparisonRows } from '../data/content';
export function CostSection() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-20" aria-labelledby="costo-title" data-id="element-35" data-mp="9cg8z0dr4syp">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-36" data-mp="4jde8ox8ndgx">
        <h2 id="costo-title" className="font-display text-3xl font-900 leading-tight text-white sm:text-4xl" style={{
        fontSize: "28px"
      }} data-id="element-37" data-mp="3vsapksgix7u6">
          ¿Cuánto cuesta NO tenerlo?
        </h2>
        <p className="mt-3 max-w-2xl text-lg text-slate-300" data-id="element-38" data-mp="3mprpuh81bbc5">
          El verdadero coste no es lo que pagas. Es lo que sigues perdiendo cada mes por decidir sin
          información.
        </p>

        <div className="mt-10 overflow-x-auto rounded-2xl border border-ink-800" data-id="element-39" data-mp="3ctop9fstzkrb">
          <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-40" data-mp="1g0wkyra11yk8">
            <caption className="sr-only" data-id="element-41" data-mp="1b1a84iy42kby">
              Comparación entre gestionar tu proyecto solar con y sin El Código Solar 360°
            </caption>
            <thead data-id="element-42" data-mp="p6094h0fhcdc">
              <tr className="bg-ink-950" data-id="element-43" data-mp="p9o3fidp62t4">
                <th scope="col" className="px-5 py-4 font-display text-xs font-700 uppercase tracking-[0.18em] text-slate-400" data-id="element-44" data-mp="t9ojt8kcwo2t">
                  Situación real
                </th>
                <th scope="col" className="px-5 py-4 font-display text-xs font-700 uppercase tracking-[0.18em] text-alert" data-id="element-45" data-mp="k8gsjag9cni8">
                  Sin Código Solar
                </th>
                <th scope="col" className="px-5 py-4 font-display text-xs font-700 uppercase tracking-[0.18em] text-leaf-400" data-id="element-46" data-mp="180f9a9yh7b2r">
                  Con Código Solar
                </th>
              </tr>
            </thead>
            <tbody data-id="element-47" data-mp="1372yb2mpz2sh">
              {comparisonRows.map(row => <tr key={row.situation} className="border-t border-ink-800" data-id="element-48" data-mp="135ruj2t9xv1d">
                  <th scope="row" className="px-5 py-4 text-sm font-600 text-white" data-id="element-49" data-mp="1qwnkrvi30i6i">
                    {row.situation}
                  </th>
                  <td className="px-5 py-4 text-sm text-slate-400" data-id="element-50" data-mp="1vpqfw82ibzot">
                    <span className="flex items-center gap-2" data-id="element-51" data-mp="25ib5bhs75opw">
                      <XIcon className="h-4 w-4 flex-none text-alert" aria-hidden="true" data-id="element-52" data-mp="20ksutmyj71fs" />
                      {row.without}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-sm text-slate-100" data-id="element-53" data-mp="1vnauum2hrwjx">
                    <span className="flex items-center gap-2" data-id="element-54" data-mp="1rjbdy2dauvq1">
                      <CheckIcon className="h-4 w-4 flex-none text-leaf-400" aria-hidden="true" data-id="element-55" data-mp="1ml1j5svhlx4y" />
                      {row.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}